import qs from "query-string";
import { useQuery } from "react-query";
import { GetLanggananMemberResponse, ParamsGetLanggananMember } from "../../constants/types";
import axios from "../axios";

const handleRequest = async (params: ParamsGetLanggananMember) => {
    const apiGetLanggananMember = qs.stringifyUrl({
        url: "/api/jenis_langganan",
        query: {
            ukmId: params.ukmId,
        },
    });
    const { data } = await axios.get<GetLanggananMemberResponse>(
        apiGetLanggananMember,
    );
    return data.data;
};

export default function useLanggananMember(params: ParamsGetLanggananMember) {
    return useQuery<GetLanggananMemberResponse["data"]>(
        ["listPelangganMember", params],
        () => handleRequest(params),
        {
            enabled: !!params?.ukmId,
        },
    );
}
